import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class PlaneAndHeightService {

  constructor(private http: HttpClient) { }

  getplaneAndHeight(stationID: string): Observable<any> {
    const url = environment.planeAndHeightURL + stationID;
    const planeAndHeightObs: Observable<object> = this.http.get(url);
    return planeAndHeightObs;
  }
}
